import React, { Component } from 'react'
import Login from '../components/auth/auth';
import Projects from '../components/project/index';
import TimeTracker from '../components/timetracker/index';
import Profile from '../components/profile/index';
import TopNavbar from '../common/navbar';
import Timer from '../common/timer';
import Onboarding from '../components/onboarding/onboarding';
import { checkAuth } from '../components/auth/auth_actions';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { Marketing } from '../components/marketing';

class AppRoutes extends Component {
  constructor(props){
    super(props);
    this.state={
      realtor:false
    }
  }

  componentDidMount(){
    this.props.checkAuth();
  }

  render() {
    const user = this.props.user
    const realtor = this.props.realtor
    const navOpen = this.props.navOpen
    return (
        <div>
            <Switch>
              <PublicRoute authed={user}  path='/login' component={Login} />
              <PublicRoute authed={user}  path='/onboarding' component={Onboarding} />
              <PrivateRoute authed={user} realtor={realtor} open={navOpen} exact path='/' component={Projects} />
              <PrivateRoute authed={user} realtor={realtor} open={navOpen} path='/timetracker' component={TimeTracker} />
              <PrivateRoute authed={user} realtor={realtor} open={navOpen} path='/profile' component={Profile} />
              <PrivateRoute authed={user} realtor={realtor} open={navOpen} path='/marketing' component={Marketing} />
              <PrivateRoute authed={user} realtor={realtor} open={navOpen} path='/marketing/:type' component={Marketing} />
              <PrivateRoute authed={user} realtor={realtor} open={navOpen} path='/marketing/:type/customize' component={Marketing} />
            </Switch>
        </div>
      );
  }
};

const PrivateRoute = ({ component: Component, open, authed, realtor, ...rest }) => (
  <Route {...rest} render={props => (
    authed ? (
      <Wrapper authed={authed} open={open} realtor={realtor}>
        <Component {...props}/>
      </Wrapper>
    ) : (
      <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }}/>
    )
  )}/>
)

const PublicRoute = ({ component: Component, authed, ...rest }) => (
  <Route {...rest} render={props => (
    !authed ? (
        <Component {...props}/>
    ) : (
      <Redirect to={{
        pathname: '/',
        state: { from: props.location }
      }}/>
    )
  )}/>
)

const Wrapper = (props) => {
  return (
    <div>
      <TopNavbar />
        <Grid fluid style={{paddingTop: 45}}>
          {
            !props.realtor?
          <Timer />: null
          }
          {props.children}
        </Grid>
    </div>
  )
}

const mapStateToProps = ({auth, common }) => {
  const {user, realtor} = auth
  const {navOpen} = common
  return {user, realtor, navOpen}
}

export default withRouter(connect(mapStateToProps, {checkAuth})(AppRoutes));



// WEBPACK FOOTER //
// ./src/common/routing.js